import { render } from "./cta.vue?vue&type=template&id=71692670&scoped=true"
import script from "./cta.vue?vue&type=script&lang=js"
export * from "./cta.vue?vue&type=script&lang=js"

import "./cta.vue?vue&type=style&index=0&id=71692670&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-71692670"

export default script